import { GetCaptchaChallengeRequest, GetCaptchaChallengeResponse, VerifyCaptchaRequest, VerifyCaptchaResponse } from "./Captcha.types";
import axios from "axios";

export const getCaptcha = async (getCaptcha: GetCaptchaChallengeRequest, baseUrl?: string): Promise<GetCaptchaChallengeResponse | undefined> => {
    const requestUri = `${baseUrl ? baseUrl : ""}/api/hip?captchaType=${getCaptcha.challengeType}&locale=${getCaptcha.locale}`;
    const headers: { [key: string]: string} = {};
    
    if (getCaptcha.correlationId) {
        headers["x-correlation-id"] = getCaptcha.correlationId
    }

    if (getCaptcha.clientRequestId) {
        headers["client-request-id"] = getCaptcha.clientRequestId
    }

    const response = await axios.get(requestUri, {
        headers: headers
    });

    if (!response) {
        return;
    }

    if (response.status !== 200)
    {
        return;
    }

    return response.data as GetCaptchaChallengeResponse;
}

export const verifyCaptcha = async (verifyCaptcha: VerifyCaptchaRequest, baseUrl?: string): Promise<VerifyCaptchaResponse | undefined> => {
    const requestUri = `${baseUrl ? baseUrl : ""}/api/hip?captchaType=${verifyCaptcha.challengeType}&azureRegion=${verifyCaptcha.azureRegion}`;

    const headers: { [key: string]: string} = {};

    if (verifyCaptcha.correlationId) {
        headers["x-correlation-id"] = verifyCaptcha.correlationId
    }

    if (verifyCaptcha.clientRequestId) {
        headers["client-request-id"] = verifyCaptcha.clientRequestId
    }

    if (process.env.NODE_ENV === "development") 
    {
        headers['X-Forwarded-For'] = 'localhost';
    }

    const response = await axios.post(requestUri, {
            inputSolution: verifyCaptcha.solution,
            challengeId: verifyCaptcha.challengeId
        }, {
            headers: {
                ...headers,
                'Content-Type': 'application/json'
            }
        }).then(response => {
            return response;
        }).catch(error => {
            return error.response;
        });

    return response.data as VerifyCaptchaResponse;
}